import { ProductReviewCategoryType } from "~/types/shop/review/ProductReviewCategoryType";

export const ProductReviewCategoryEntity = function (data: any): ProductReviewCategoryType {
    return {
        title: data?.attributes?.title,
        textBeforeContent: data?.attributes?.text_before_content,
        textAfterContent: data?.attributes?.text_after_content,
        slug: data?.attributes?.slug,
        svgInline: data?.attributes?.svg_icon,
        url: `/reviews/category-${data?.attributes?.slug}`,
    };
};